<template>
  <v-container class="my-5">
    <v-row justify="center" class="black--text">
      <v-col cols="12" md="8">
        <div>
          <v-btn
            class="mr-2 mb-2"
            fab
            depressed
            dark
            x-small
            :to="{ name: 'Landing' }">
            <v-icon dark>
              mdi-arrow-left-thick
            </v-icon>
          </v-btn>
          <span class="title">Back to home</span>
        </div>
      </v-col>
      <v-col cols="12" md="8">
        <v-card outlined rounded="lg">
          <v-card-text>
            <alertsp :alertdata="alertdata"></alertsp>
            <v-row class="black--text">
              <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </v-col>
              <v-col cols="12" md="12" v-if="!loading.detail && detaildata.length" class="text-center">
                <div class="text-md-h5 font-weight-bold">e-Learning PNB</div>
                <p>Apakah anda yakin untuk bergabung dengan kelas berikut:</p>
                <v-divider></v-divider>
                <div class="my-3 font-weight-bold">
                  <div>{{ detaildata[0].nama_class }}</div>
                  <div>{{ detaildata[0].prodi_class }}</div>
                  <div>Semester {{ detaildata[0].semester_class }}</div>
                  <div>{{ detaildata[0].matkul_class }}</div>
                  <div>Kelas: {{ detaildata[0].mhs_class }}</div>
                  <div>T.A {{ detaildata[0].year_class }}</div>
                </div>
                <v-btn
                  v-if="detaildata[0].s_kelas_tim === '1'"
                  class="white--text"
                  :color="maincolor"
                  @click="joinClass"
                  :loading="loading.verify"
                  :disabled="loading.verify">
                  Gabung ke kelas
                </v-btn>
                <div
                  class="my-3 font-weight-bold"
                  v-if="detaildata[0].s_kelas_tim === '0'">
                  <div class="text-md-h6">Bukan merupakan kelas Tim Teaching</div>
                </div>
              </v-col>
              <v-col cols="12" md="12" v-if="!loading.verify && verified" class="text-center">
                <v-btn
                  outlined
                  :color="maincolor"
                  :to="{ name: 'Login' }">
                  Log In
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Invitedosen',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
      verify: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    datauser: null,
    class: '',
    verified: false,
    detaildata: [],
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  watch: {
    '$route.query.class'(val) {
      if (val) {
        this.class = val;
        this.getClass();
      }
    },
  },
  mounted() {
    if (this.$route.query.class && this.$route.query.class !== '') {
      this.class = this.$route.query.class;
      this.getClass();
    } else {
      this.alertdata.show = true;
      this.alertdata.type = 'error';
      this.alertdata.text = 'Invalid URL!';
    }
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getClass() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.class && this.tokenscr) {
        this.detaildata = [];
        this.axios
          .get(
            this.api + '/api/kelas/code/' + this.class,
            {
              params: {},
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Kelas tidak ditemukan!';
      }
    },
    joinClass() {
      // console.log(this.class);
      this.alertdata.show = false;
      if (this.class && this.tokenscr) {
        this.loading.verify = true;
        this.axios
          .post(
            this.api + '/api/kelas/joindosen',
            qs.stringify(
              {
                class: this.class,
                idclass: this.detaildata[0].id_class,
              },
            ),
            {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.alertdata.show = true;
                this.alertdata.type = 'success';
                this.alertdata.text = 'Selamat anda berhasil bergabung dengan kelas ini.';
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.verify = false;
          })
          .catch((error) => {
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
            this.loading.verify = false;
          });
      } else {
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Invalid URL!';
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
